module.exports = __webpack_public_path__ + "img/menu-predict-icon-red.31b71980.png";